import { render } from "./roleLogin.vue?vue&type=template&id=ac9c2358"
import script from "./roleLogin.vue?vue&type=script&lang=js"
export * from "./roleLogin.vue?vue&type=script&lang=js"

import "./roleLogin.vue?vue&type=style&index=0&id=ac9c2358&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__